<template>

<div class="wrapper" :class="{'is-fill': fill, 'is-grid': grid, 'is-loading': loading}">

	<slot></slot>

</div>

</template>

<script>

export default {

	props: ['fill', 'grid', 'loading']

}

</script>

<style scoped>

.wrapper {
	width: 100%;
	flex-shrink: 0;
}

.wrapper.is-loading {
    background-position: 50% 50%;
	background-repeat: no-repeat;
	background-image: url(~@/assets/app.load.gif);
}

.wrapper.is-loading > * {
	opacity: 0;
}

.wrapper.is-fill {
	flex-grow: 1;
}

.wrapper.is-grid {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}

</style>